


































































































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import StepContainer from '@ui/AudienceSetWizard/StepContainer'
import GettingStartedTutorialModal from '@ui/AudienceSetWizard/components/tutorials/GettingStarted/GettingStartedTutorialModal'

settings =
  name: 'VenueOverviewStep'

  vue:
    props: ['wizard', 'step']
    mixins: [WizardService.step()]

    components: {
      StepContainer,
      GettingStartedTutorialModal,
    }

    data: ->
      newPrimaryType: ''
      newListingType: ''
      newAudienceActivity: ''

      tutorialModal:
        show: @wizard.mode is 'CREATE'

    computed:
      listingTypes: -> @$store.marketplace.listing.types
      availableListingTypes: ->
        types = { ...@listingTypes }
        ignored = [
          @wizard.audienceSetData.pitch.primary_type,
          ...@wizard.audienceSetData.pitch.types,
        ]
        delete types[key] for key of types when key in ignored
        types

      listingActivities: -> @$store.marketplace.listing.activities

      canSubmit: ->
        { title, pitch: { primary_type } } = @wizard.audienceSetData
        title?.trim() and primary_type

    methods:
      hiRemovePrimaryType: (tag) ->
        @wizard.audienceSetData.pitch.primary_type = null

      hiAddPrimaryType: ->
        @wizard.audienceSetData.pitch.primary_type = @newPrimaryType
        @newPrimaryType = ''

      hiRemoveType: (tag) ->
        @removeTag tag, @wizard.audienceSetData.pitch.types

      hiAddType: ->
        @addTag @newListingType, @wizard.audienceSetData.pitch.types
        @newListingType = ''

      hiRemoveAudienceActivity: (tag) ->
        @removeTag tag, @wizard.audienceSetData.pitch.activity_tags

      hiAddAudienceActivity: ->
        @addTag @newAudienceActivity, @wizard.audienceSetData.pitch.activity_tags
        @audienceActivityInputVisible = false
        @newAudienceActivity = ''

      addTag: (tag, list) -> list.indexOf(tag) is -1 and list.push(tag) if tag
      removeTag: (tag, list) -> list.splice(list.indexOf(tag), 1)

      formatType: (type) -> @listingTypes[type]
      formatAudienceActivity: (audienceActivity) -> @listingActivities[audienceActivity]

export default VueOptions.vue settings
